
import { TemplateCategory } from "./types";

export const extrajudiciaisCategory: TemplateCategory = {
  id: 'extrajudiciais',
  name: 'Extrajudiciais',
  emoji: '📂',
  description: 'Documentos fora do processo judicial',
  subcategories: [
    {
      id: 'notificacoes',
      name: 'Notificações e Comunicações',
      emoji: '📝',
      templates: [
        {
          id: 'not-extrajudicial',
          name: 'Notificação extrajudicial',
          type: 'Notificação',
          description: 'Modelo de notificação extrajudicial',
          icon: 'FileText',
          content: `NOTIFICAÇÃO EXTRAJUDICIAL

[NOME DO NOTIFICANTE], [QUALIFICAÇÃO], vem, por meio da presente, NOTIFICAR [NOME DO NOTIFICADO], [QUALIFICAÇÃO], para que, no prazo de [PRAZO] dias, contados do recebimento desta notificação:

[DESCREVER A OBRIGAÇÃO/SOLICITAÇÃO]

Caso V.Sa. não atenda ao presente chamamento no prazo estipulado, restará caracterizada a mora e/ou inadimplemento, ficando sujeito às consequências legais cabíveis.

Para tanto, fica devidamente NOTIFICADO.

[LOCAL], [DATA]

_________________________________
[NOME DO NOTIFICANTE]`
        },
        {
          id: 'contra-notificacao',
          name: 'Contra-notificação',
          type: 'Contra-notificação',
          description: 'Resposta a uma notificação recebida',
          icon: 'FileText',
          content: `CONTRA-NOTIFICAÇÃO

[NOME DO CONTRA-NOTIFICANTE], [QUALIFICAÇÃO], vem, por meio da presente, responder à notificação recebida em [DATA], pelos seguintes motivos:

[FUNDAMENTAÇÃO DA RESPOSTA]

Desta forma, [REJEITA/ACEITA PARCIALMENTE] as alegações apresentadas na notificação em referência.

[LOCAL], [DATA]

_________________________________
[NOME DO CONTRA-NOTIFICANTE]`
        },
        {
          id: 'carta-rescisao',
          name: 'Carta de rescisão contratual',
          type: 'Rescisão',
          description: 'Comunicação de rescisão de contrato',
          icon: 'FileText',
          content: `CARTA DE RESCISÃO CONTRATUAL

[NOME DA PARTE], [QUALIFICAÇÃO], vem, pela presente, comunicar a rescisão do contrato [TIPO DE CONTRATO] celebrado em [DATA] com [NOME DA CONTRAPARTE].

A rescisão se dá com fundamento em [CLÁUSULA CONTRATUAL/DISPOSITIVO LEGAL], pelos seguintes motivos:

[MOTIVOS DA RESCISÃO]

A rescisão produzirá efeitos a partir de [DATA].

[LOCAL], [DATA]

_________________________________
[NOME DA PARTE]`
        },
        {
          id: 'carta-advertencia',
          name: 'Carta de advertência',
          type: 'Advertência',
          description: 'Advertência formal',
          icon: 'FileText',
          content: `CARTA DE ADVERTÊNCIA

[NOME DO ADVERTENTE], [QUALIFICAÇÃO], vem, pela presente, ADVERTIR [NOME DO ADVERTIDO] sobre [DESCRIÇÃO DO COMPORTAMENTO/SITUAÇÃO].

Tal comportamento/situação está em desconformidade com [NORMA/CONTRATO/ACORDO], podendo acarretar [CONSEQUÊNCIAS].

Caso persista tal situação, medidas mais severas poderão ser adotadas.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVERTENTE]`
        },
        {
          id: 'carta-cobranca',
          name: 'Carta de cobrança',
          type: 'Cobrança',
          description: 'Cobrança amigável de débito',
          icon: 'FileText',
          content: `CARTA DE COBRANÇA

[NOME DO CREDOR], [QUALIFICAÇÃO], vem, pela presente, cobrar de [NOME DO DEVEDOR] o pagamento da dívida no valor de R$ [VALOR], vencida em [DATA DE VENCIMENTO].

A dívida refere-se a [ORIGEM DA DÍVIDA].

Solicitamos que o pagamento seja efetuado no prazo de [PRAZO] dias, evitando assim medidas judiciais.

Permanecemos à disposição para negociação.

[LOCAL], [DATA]

_________________________________
[NOME DO CREDOR]`
        },
        {
          id: 'carta-proposta',
          name: 'Carta-proposta',
          type: 'Proposta',
          description: 'Proposta comercial ou negocial',
          icon: 'FileText',
          content: `CARTA-PROPOSTA

[NOME DO PROPONENTE], [QUALIFICAÇÃO], vem, pela presente, apresentar proposta a [NOME DO DESTINATÁRIO] para:

[DESCRIÇÃO DA PROPOSTA]

CONDIÇÕES:
[LISTAR AS CONDIÇÕES]

Esta proposta tem validade até [DATA DE VALIDADE].

Aguardamos retorno.

[LOCAL], [DATA]

_________________________________
[NOME DO PROPONENTE]`
        },
        {
          id: 'intimacao-extrajudicial',
          name: 'Intimação extrajudicial',
          type: 'Intimação',
          description: 'Intimação para cumprimento de obrigação',
          icon: 'AlertTriangle',
          content: `INTIMAÇÃO EXTRAJUDICIAL

[NOME DO INTIMANTE], [QUALIFICAÇÃO], vem, por meio da presente, INTIMAR [NOME DO INTIMADO], [QUALIFICAÇÃO], para que, no prazo de [PRAZO] dias:

[OBRIGAÇÃO A SER CUMPRIDA]

O descumprimento da presente intimação ensejará as medidas judiciais cabíveis.

[LOCAL], [DATA]

_________________________________
[NOME DO INTIMANTE]`
        },
        {
          id: 'comunicacao-ruptura',
          name: 'Comunicação de ruptura de negociação',
          type: 'Comunicação',
          description: 'Comunicação de fim de negociações',
          icon: 'X',
          content: `COMUNICAÇÃO DE RUPTURA DE NEGOCIAÇÃO

[NOME], [QUALIFICAÇÃO], vem comunicar a [NOME DA CONTRAPARTE] a ruptura das negociações iniciadas em [DATA].

MOTIVO: [RAZÃO DA RUPTURA]

Ficam sem efeito todos os entendimentos preliminares.

[LOCAL], [DATA]

_________________________________
[NOME]`
        },
        {
          id: 'notificacao-mora',
          name: 'Notificação de mora',
          type: 'Notificação',
          description: 'Constituição formal em mora',
          icon: 'Clock',
          content: `NOTIFICAÇÃO DE MORA

[NOME DO CREDOR], [QUALIFICAÇÃO], vem NOTIFICAR [NOME DO DEVEDOR] para constituí-lo em MORA quanto ao pagamento da obrigação vencida em [DATA].

VALOR EM ATRASO: R$ [VALOR]

Fica V.Sa. constituído em mora a partir do recebimento desta notificação, sujeitando-se ao pagamento de juros moratórios, correção monetária e demais cominações legais.

[LOCAL], [DATA]

_________________________________
[NOME DO CREDOR]`
        },
        {
          id: 'comunicacao-mudanca-endereco',
          name: 'Comunicação de mudança de endereço',
          type: 'Comunicação',
          description: 'Comunicação de alteração de endereço',
          icon: 'MapPin',
          content: `COMUNICAÇÃO DE MUDANÇA DE ENDEREÇO

[NOME], [QUALIFICAÇÃO], vem comunicar a mudança de endereço:

ENDEREÇO ANTERIOR: [ENDEREÇO ANTIGO]
NOVO ENDEREÇO: [NOVO ENDEREÇO]

A mudança será efetiva a partir de [DATA].

[LOCAL], [DATA]

_________________________________
[NOME]`
        }
      ]
    },
    {
      id: 'pareceres',
      name: 'Pareceres e Requerimentos',
      emoji: '📑',
      templates: [
        {
          id: 'parecer-juridico',
          name: 'Parecer jurídico',
          type: 'Parecer',
          description: 'Análise jurídica de questão específica',
          icon: 'Scale',
          content: `PARECER JURÍDICO

CONSULENTE: [NOME]
ASSUNTO: [MATÉRIA CONSULTADA]

I - RELATÓRIO
[EXPOSIÇÃO DOS FATOS]

II - FUNDAMENTAÇÃO JURÍDICA
[ANÁLISE LEGAL DA QUESTÃO]

III - CONCLUSÃO
[PARECER FINAL]

[LOCAL], [DATA]

_________________________________
[NOME DO PARECERISTA]
[QUALIFICAÇÃO PROFISSIONAL]`
        },
        {
          id: 'requerimento-administrativo',
          name: 'Requerimento administrativo',
          type: 'Requerimento',
          description: 'Solicitação a órgão público',
          icon: 'Building',
          content: `REQUERIMENTO ADMINISTRATIVO

Ao [ÓRGÃO/AUTORIDADE]

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem respeitosamente requerer:

[PEDIDO ESPECÍFICO]

FUNDAMENTAÇÃO:
[BASE LEGAL E FÁTICA]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]

DOCUMENTOS ANEXOS:
[LISTAR DOCUMENTOS]`
        },
        {
          id: 'pedido-informacao-lai',
          name: 'Pedido de informação (Lei de Acesso)',
          type: 'LAI',
          description: 'Solicitação com base na Lei de Acesso à Informação',
          icon: 'FileText',
          content: `PEDIDO DE ACESSO À INFORMAÇÃO
(Lei nº 12.527/2011)

Ao [ÓRGÃO PÚBLICO]

[NOME DO SOLICITANTE], [QUALIFICAÇÃO], com base na Lei nº 12.527/2011 (Lei de Acesso à Informação), vem solicitar:

INFORMAÇÃO SOLICITADA:
[DETALHAR A INFORMAÇÃO]

JUSTIFICATIVA (opcional):
[MOTIVO DA SOLICITAÇÃO]

FORMA DE RECEBIMENTO PREFERIDA:
( ) E-mail: [EMAIL]
( ) Correspondência: [ENDEREÇO]
( ) Presencial

[LOCAL], [DATA]

_________________________________
[NOME DO SOLICITANTE]`
        },
        {
          id: 'requisicao-documentos',
          name: 'Requisição de documentos',
          type: 'Requisição',
          description: 'Solicitação de documentos',
          icon: 'FileText',
          content: `REQUISIÇÃO DE DOCUMENTOS

Ao [DESTINATÁRIO]

[NOME DO SOLICITANTE], [QUALIFICAÇÃO], vem, pela presente, requerer o fornecimento dos seguintes documentos:

DOCUMENTOS SOLICITADOS:
[LISTAR OS DOCUMENTOS]

FINALIDADE:
[INFORMAR O PROPÓSITO]

PRAZO SOLICITADO: [PRAZO]

[LOCAL], [DATA]

_________________________________
[NOME DO SOLICITANTE]`
        },
        {
          id: 'parecer-tecnico',
          name: 'Parecer técnico',
          type: 'Parecer',
          description: 'Análise técnica especializada',
          icon: 'Cog',
          content: `PARECER TÉCNICO

SOLICITANTE: [NOME]
OBJETO: [MATÉRIA ANALISADA]

I - METODOLOGIA
[MÉTODO DE ANÁLISE]

II - ANÁLISE TÉCNICA
[DESENVOLVIMENTO TÉCNICO]

III - CONCLUSÕES
[CONCLUSÕES TÉCNICAS]

[LOCAL], [DATA]

_________________________________
[NOME DO TÉCNICO]
[QUALIFICAÇÃO/REGISTRO PROFISSIONAL]`
        }
      ]
    },
    {
      id: 'contratos-extras',
      name: 'Contratos e Acordos',
      emoji: '📄',
      templates: [
        {
          id: 'acordo-extrajudicial',
          name: 'Acordo extrajudicial',
          type: 'Acordo',
          description: 'Composição amigável de conflito',
          icon: 'Handshake',
          content: `ACORDO EXTRAJUDICIAL

[NOME DA PARTE 1], [QUALIFICAÇÃO] e [NOME DA PARTE 2], [QUALIFICAÇÃO], celebram o presente acordo para resolver amigavelmente a questão referente a [OBJETO DO CONFLITO].

CLÁUSULAS:

1ª - [PRIMEIRA CONDIÇÃO]
2ª - [SEGUNDA CONDIÇÃO]
3ª - Dão-se recíproca e plena quitação

Por estarem justos e acordados, assinam o presente.

[LOCAL], [DATA]

_________________________________     _________________________________
[PARTE 1]                             [PARTE 2]`
        },
        {
          id: 'termo-compromisso',
          name: 'Termo de compromisso',
          type: 'Termo',
          description: 'Compromisso formal de obrigação',
          icon: 'FileCheck',
          content: `TERMO DE COMPROMISSO

[NOME DO COMPROMISSÁRIO], [QUALIFICAÇÃO], assume o presente COMPROMISSO perante [NOME DO COMPROMISSATÁRIO]:

OBRIGAÇÕES ASSUMIDAS:
[DESCRIÇÃO DAS OBRIGAÇÕES]

PRAZO: [PRAZO PARA CUMPRIMENTO]

PENALIDADES: [CONSEQUÊNCIAS DO DESCUMPRIMENTO]

[LOCAL], [DATA]

_________________________________
[NOME DO COMPROMISSÁRIO]`
        },
        {
          id: 'distrato',
          name: 'Distrato',
          type: 'Distrato',
          description: 'Desfazimento de contrato por acordo',
          icon: 'X',
          content: `DISTRATO

[NOME DA PARTE 1] e [NOME DA PARTE 2], partes no contrato celebrado em [DATA], resolvem, de comum acordo, desfazê-lo mediante as seguintes condições:

CONDIÇÕES DO DISTRATO:
[CONDIÇÕES PARA DESFAZIMENTO]

EFEITOS: O contrato fica sem efeito a partir de [DATA]

QUITAÇÃO: Dão-se recíproca quitação

[LOCAL], [DATA]

_________________________________     _________________________________
[PARTE 1]                             [PARTE 2]`
        },
        {
          id: 'aditivo-contratual',
          name: 'Aditivo contratual',
          type: 'Aditivo',
          description: 'Alteração de cláusulas contratuais',
          icon: 'Edit',
          content: `ADITIVO CONTRATUAL

[NOME DA PARTE 1] e [NOME DA PARTE 2], partes no contrato celebrado em [DATA], resolvem alterá-lo mediante as seguintes modificações:

ALTERAÇÕES:
[DESCRIÇÃO DAS ALTERAÇÕES]

CLÁUSULAS MANTIDAS: Permanecem inalteradas as demais cláusulas

[LOCAL], [DATA]

_________________________________     _________________________________
[PARTE 1]                             [PARTE 2]`
        },
        {
          id: 'declaracao-hipossuficiencia',
          name: 'Declaração de hipossuficiência',
          type: 'Declaração',
          description: 'Declaração para assistência judiciária gratuita',
          icon: 'FileText',
          content: `DECLARAÇÃO DE HIPOSSUFICIÊNCIA

Eu, [NOME COMPLETO], [QUALIFICAÇÃO], DECLARO, sob as penas da lei, que não possuo condições financeiras de arcar com as custas processuais e honorários advocatícios sem prejuízo do sustento próprio e familiar.

RENDA FAMILIAR: R$ [VALOR]
DESPESAS MENSAIS: R$ [VALOR]
DEPENDENTES: [NÚMERO]

Solicito os benefícios da assistência judiciária gratuita.

[LOCAL], [DATA]

_________________________________
[NOME DO DECLARANTE]`
        },
        {
          id: 'cessao-direitos',
          name: 'Cessão de direitos',
          type: 'Cessão',
          description: 'Transferência de direitos',
          icon: 'ArrowRight',
          content: `CESSÃO DE DIREITOS

CEDENTE: [NOME], [QUALIFICAÇÃO]
CESSIONÁRIO: [NOME], [QUALIFICAÇÃO]

O CEDENTE cede ao CESSIONÁRIO os seguintes direitos:

DIREITOS CEDIDOS:
[DESCRIÇÃO DOS DIREITOS]

VALOR DA CESSÃO: R$ [VALOR]

RESPONSABILIDADES: [DEFINIR RESPONSABILIDADES]

[LOCAL], [DATA]

_________________________________     _________________________________
CEDENTE                               CESSIONÁRIO`
        },
        {
          id: 'mandato-procuracao',
          name: 'Mandato específico',
          type: 'Mandato',
          description: 'Mandato para ato específico',
          icon: 'UserCheck',
          content: `MANDATO ESPECÍFICO

MANDANTE: [NOME], [QUALIFICAÇÃO]
MANDATÁRIO: [NOME], [QUALIFICAÇÃO]

O MANDANTE confere ao MANDATÁRIO poderes específicos para:

PODERES CONFERIDOS:
[ATOS ESPECÍFICOS AUTORIZADOS]

PRAZO: [PRAZO DE VALIDADE]

LIMITAÇÕES: [RESTRIÇÕES, SE HOUVER]

[LOCAL], [DATA]

_________________________________
[NOME DO MANDANTE]`
        },
        {
          id: 'protocolo-intencoes',
          name: 'Protocolo de intenções',
          type: 'Protocolo',
          description: 'Acordo preliminar de intenções',
          icon: 'FileText',
          content: `PROTOCOLO DE INTENÇÕES

[NOME DA PARTE 1] e [NOME DA PARTE 2] celebram este protocolo para estabelecer as bases de futura parceria:

OBJETO: [FINALIDADE DA PARCERIA]

INTENÇÕES:
[DESCRIÇÃO DAS INTENÇÕES]

PRAZO PARA DEFINIÇÃO: [PRAZO]

Este protocolo não gera obrigações definitivas.

[LOCAL], [DATA]

_________________________________     _________________________________
[PARTE 1]                             [PARTE 2]`
        },
        {
          id: 'quitacao-geral',
          name: 'Quitação geral',
          type: 'Quitação',
          description: 'Quitação ampla e irrestrita',
          icon: 'CheckCircle',
          content: `QUITAÇÃO GERAL

[NOME DO DEVEDOR], [QUALIFICAÇÃO], dá a [NOME DO CREDOR] plena, geral e irrevogável QUITAÇÃO referente a:

OBJETO DA QUITAÇÃO:
[DESCRIÇÃO DO QUE ESTÁ SENDO QUITADO]

VALOR QUITADO: R$ [VALOR]

Nada mais tendo a reclamar a qualquer título.

[LOCAL], [DATA]

_________________________________
[NOME DO DEVEDOR]`
        },
        {
          id: 'termo-confidencialidade',
          name: 'Termo de confidencialidade',
          type: 'Confidencialidade',
          description: 'Acordo de sigilo e confidencialidade',
          icon: 'Lock',
          content: `TERMO DE CONFIDENCIALIDADE

[NOME DA PARTE REVELADORA] e [NOME DA PARTE RECEPTORA] acordam as seguintes condições de confidencialidade:

INFORMAÇÕES CONFIDENCIAIS:
[DEFINIR INFORMAÇÕES SIGILOSAS]

OBRIGAÇÕES:
- Manter absoluto sigilo
- Não divulgar a terceiros
- Usar apenas para fins acordados

PRAZO: [PRAZO DE VIGÊNCIA]

PENALIDADES: [MULTA POR DESCUMPRIMENTO]

[LOCAL], [DATA]

_________________________________     _________________________________
[PARTE REVELADORA]                    [PARTE RECEPTORA]`
        }
      ]
    }
  ]
};
